import { createContext } from "react";

export const AddUserDispatchContext = createContext();
